import { SearchBlock } from '../types';

export function serialiseSearchBlocks<T>({ searchBlocks }: { searchBlocks: SearchBlock<T>[] }): string {
    if (searchBlocks.length === 0) {
        return '';
    }
    return JSON.stringify(searchBlocks);
}
